import React from 'react';
import PropTypes from 'prop-types';

import { nanoid } from 'nanoid'
import displayName from 'component-lib/displayName';
import styles from './Accordions.scss';

function AccordionItem({
    checked,
    content,
    children,
    dataLabel,
    label,
    onClick,
    size,
    type,
}) {
    const id = nanoid();
    const accordionType = type.charAt();

    return (
        <div className={styles['accordion-item']} data-label={dataLabel}>
            <input
                id={id}
                className={styles['input-hidden']}
                type={type}
                name="toggle"
                defaultChecked={checked ? 'checked' : void 0}
            />
            <label
                role="presentation"
                className={styles[`accordion-title-${accordionType}-${size}`]}
                htmlFor={id}
                onClick={onClick}
            >
                {label}
            </label>
            <div
                id={id}
                className={styles[`accordion-content-${accordionType}-${size}`]}
            >
                {content || children}
            </div>
        </div>
    );
}

AccordionItem.displayName = displayName('Accordions/AccordionItem');

AccordionItem.propTypes = {
    checked: PropTypes.bool,
    content: PropTypes.node,
    children: PropTypes.node,
    dataLabel: PropTypes.string,
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(['small', 'large']),
    type: PropTypes.oneOf(['checkbox', 'radio']),
};

AccordionItem.defaultProps = {
    size: 'large',
    type: 'checkbox',
    checked: false,
    content: null,
    children: null,
    dataLabel: '',
    onClick: () => {},
};

export default AccordionItem;
